import { User } from '.';

export interface AwardNominationReviewer {
  awardNominationReviewerId: number;
  awardId: number;
  emailAddress: string;
  user?: User;
}

export function blankAwardNominationReviewer(): AwardNominationReviewer {
  return {
    awardNominationReviewerId: 0,
    awardId: 0,
    emailAddress: ''
  };
}
